import { gql } from "@apollo/client";

export const CREATE_NOTIFICATION = gql`
mutation SaveVisitaNotificacion($input: AddVisitaNotificacionInput!) {
    saveVisitaNotificacion(input: $input) {
        success
        error
        valorEsperado {
            idVisitaEvaluacionNotificacion
            idEvaluacion
            idNotificacion
        }
    }
}`;